function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pfx88368__filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "pfx88368__path-2",
  points: "0 0 57 0 57 29 0 29"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "pfx88368__Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "pfx88368__text/sign-off",
  transform: "translate(-282.000000, -49.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "pfx88368__logo-white",
  transform: "translate(282.000000, 49.000000)",
  filter: "url(#pfx88368__filter-1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "pfx88368__mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx88368__path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "pfx88368__Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57,-0.000120748306 L44.1726497,-0.000120748306 C44.1726497,9.27817912 38.254126,16.6767297 28.6924461,16.6767297 C18.9996615,16.6767297 12.8249014,9.27817912 12.8249014,-0.000120748306 L-5.97287685e-05,-0.000120748306 C-5.97287685e-05,15.982427 12.8780601,29 28.5643279,29 C44.3739356,29 57,16.1116276 57,-0.000120748306",
  id: "pfx88368__Fill-1",
  fill: "#EE4926",
  mask: "url(#pfx88368__mask-3)"
})))));

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "29px",
    viewBox: "0 0 57 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.23db1048.svg";
export { ForwardRef as ReactComponent };